// Supabase Query Interceptor
// This file intercepts and fixes Supabase queries to use correct table names

import { supabase } from '../config/supabase';

// Override Supabase to fix table names
const originalFrom = supabase.from.bind(supabase);

(supabase as any).from = function(table: string) {
  // Map old table names to new ones
  const tableMapping: { [key: string]: string } = {
    'customers': 'clients',  // Fix customers -> clients
    'customer': 'clients',   // Also handle singular
  };

  const actualTable = tableMapping[table] || table;
  
  if (actualTable !== table) {
    console.log(`🔄 Redirecting Supabase query from '${table}' to '${actualTable}'`);
  }

  return originalFrom(actualTable);
};

// Export fixed supabase instance
export { supabase as fixedSupabase };

console.log('✅ Supabase table fix applied');
